import { LegalPageLayout } from './LegalPageLayout';

export function RisoluzioneControversiePage() {
  return (
    <LegalPageLayout title="Policy sulla Risoluzione delle Controversie (ADR/ODR)">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <p>
                      <strong>Società:</strong> Klaro7 S.r.l.s. <strong>Riferimento Legale:</strong> Codice del
                      Consumo (D.Lgs. 206/2005) e Regolamento (UE) 524/2013.
                    </p>
      
                    <h2>1. OBIETTIVO E AMBITO DI APPLICAZIONE</h2>
                    <p>
                      La presente Policy stabilisce le procedure disponibili per la risoluzione amichevole delle
                      controversie tra Klaro7 S.r.l.s. e l&apos;Utente Consumatore (di seguito &quot;Utente&quot;),
                      relative all&apos;utilizzo dei servizi offerti sulla Piattaforma.
                    </p>
      
                    <h2>2. PROCEDURA DI RECLAMO INTERNO (Fase Preliminare)</h2>
                    <p>
                      Prima di ricorrere a procedure esterne di risoluzione, l&apos;Utente è tenuto a tentare una
                      conciliazione amichevole interna:
                    </p>
                    <ul>
                      <li>
                        <strong>Invio del Reclamo:</strong> L&apos;Utente deve inviare un reclamo formale e
                        dettagliato tramite e-mail all&apos;indirizzo{' '}
                        <a href="mailto:assistenza@klaro7.com">assistenza@klaro7.com</a>
                      </li>
                      <li>
                        <strong>Contenuto:</strong> Il reclamo deve includere data, ora, dettagli del servizio
                        contestato, nome dell&apos;Operatore e la motivazione chiara della contestazione.
                      </li>
                      <li>
                        <strong>Tempo di Risposta:</strong> Klaro7 si impegna a fornire una risposta motivata entro
                        il termine massimo di 30 giorni dal ricevimento del reclamo, come previsto dalle Condizioni
                        Generali d&apos;Uso.
                      </li>
                    </ul>
      
                    <h2>3. RISOLUZIONE ALTERNATIVA DELLE CONTROVERSIE (ADR)</h2>
                    <p>
                      Qualora il reclamo non venga risolto in modo soddisfacente tramite la procedura interna
                      descritta al punto precedente, l&apos;Utente Consumatore ha la facoltà di ricorrere alle
                      procedure di Risoluzione Alternativa delle Controversie (Alternative Dispute Resolution – ADR)
                      previste dal Codice del Consumo.
                    </p>
                    <p>
                      Klaro7 informa l&apos;Utente che, ai sensi dell&apos;art. 141-quater del Codice del Consumo, è
                      disponibile a valutare la risoluzione amichevole della controversia presso gli organismi di
                      mediazione iscritti nell&apos;elenco ufficiale tenuto dal Ministero delle Imprese e del Made in
                      Italy (MIMIT). L&apos;elenco degli organismi ADR è consultabile pubblicamente sul sito
                      istituzionale del Ministero.
                    </p>
      
                    <h2>4. RISOLUZIONE DELLE CONTROVERSIE ONLINE (ODR)</h2>
                    <p>
                      Inoltre, il Consumatore residente nell&apos;Unione Europea ha la possibilità di ricorrere alla
                      piattaforma per la risoluzione online delle controversie (Online Dispute Resolution – ODR)
                      istituita dalla Commissione Europea.
                    </p>
                    <ul>
                      <li>
                        <strong>Piattaforma ODR:</strong> L&apos;Utente può accedere alla piattaforma ODR tramite il
                        seguente link:{' '}
                        <a href="http://ec.europa.eu/odr" target="_blank" rel="noopener noreferrer">
                          http://ec.europa.eu/odr
                        </a>
                      </li>
                      <li>
                        <strong>Riferimento Klaro7:</strong> L&apos;indirizzo e-mail di Klaro7 per la piattaforma ODR
                        è: <a href="mailto:assistenza@klaro7.com">assistenza@klaro7.com</a>
                      </li>
                    </ul>
      
                    <h2>5. FORO COMPETENTE</h2>
                    <p>
                      Resta fermo il diritto dell&apos;Utente Consumatore di ricorrere al giudice ordinario per la
                      risoluzione delle controversie. La competenza territoriale spetta al foro di residenza o
                      domicilio dell&apos;Utente, se ubicato nel territorio dello Stato Italiano.
                    </p>
    </LegalPageLayout>
  );
}
